import { render } from "./BindingInfoView.vue?vue&type=template&id=716a940e&scoped=true"
import script from "./BindingInfoView.vue?vue&type=script&lang=js"
export * from "./BindingInfoView.vue?vue&type=script&lang=js"

import "./assets/index.css?vue&type=style&index=0&id=716a940e&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716a940e"]])

export default __exports__